// src/utils/services/CodingOpportunities/updatePatientStatus.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CodingOpportunities/pat-status-by-cip`;

/**
 * Actualiza el estado del paciente en Coding Opportunities.
 *
 * @param {Object} params
 * @param {string} params.cipId - ID del paciente (CIP)
 * @param {number} params.patStatus - ID del estado del paciente (0-7)
 * @param {number} params.employeeUpdate - ID del empleado que realiza la actualización
 * @returns {Promise<Object>} - Respuesta del servidor
 */
const updatePatientStatus = async ({ cipId, patStatus, employeeUpdate }) => {
  try {
    const response = await axios.put(
      API_URL,
      {
        cipId,
        patStatus,
        employeeUpdate,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating patient status:", error);
    throw error;
  }
};

export default updatePatientStatus;
